import React from "react";
import { commonRootUrl } from "../../../common/api/paymentApi";
import HtmlTooltip from "../HtmlTooltilp";



export type PaymentFirmInformationsType = {
    firmName: string,
    taxCode: string,
    email: string,
    web?: string,
    logourl: string, 
}
const FirmInformationArea = (props: PaymentFirmInformationsType) => {

    const { email, firmName, taxCode, web, logourl } = props



    return (
        <div>
            <div className="px-6 py-4 pb-2 rounded-lg   mt-6 ">

                <div className="w-full h-10 relative">
                    <img src={commonRootUrl + "/etahsilatapitest/Uploads/firm_logos/" + logourl} width={"auto"} className="max-h-full m-auto" />
                </div>

                <div className="text-center text-neutral-500 text-xs font-bold  mt-3">{firmName}</div>
            </div>
            <div className="mt-3 grid grid-cols-2 gap-y-2">

                <div className=" text-zinc-400 text-xs font-bold ">VKN / TCKN</div>
                <div className=" text-zinc-800 text-xs font-normal ">{taxCode}</div> {/*break-all truncate*/}

                <div className=" text-zinc-400 text-xs font-bold ">E-posta</div>
                <div>
                    {email.length < 30 ? <div className="text-zinc-800 text-xs font-normal">{email}</div> :
                        <HtmlTooltip
                            title={
                                <React.Fragment>
                                    {email}
                                </React.Fragment>
                            }
                        >
                            <div className="text-zinc-800 text-xs font-normal truncate">
                                {email}
                            </div>
                        </HtmlTooltip>}
                </div>
            
                {web && (
                    <>
                        <div className=" text-zinc-400 text-xs font-bold ">Web Sitesi</div>
                        <div>
                            {web.length < 30 ? <div className="text-zinc-800 text-xs font-normal">{web}</div> :
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            {web}
                                        </React.Fragment>
                                    }
                                >
                                    <div className="text-zinc-800 text-xs font-normal truncate">
                                        {web}
                                    </div>
                                </HtmlTooltip>}
                        </div>
                    </>
                )}
              
            </div>
        </div>
    );
}
export default FirmInformationArea;